import { getFunctionData } from "../../store/functionStore";

export function parseNumericInput(value) {
  if (value === "" || value === null || value === undefined) return "";

  const parsed = Number(value);
  return Number.isNaN(parsed) ? value : parsed;
}

export function minmaxTest(value, min, max) {
  if (value === "" || value === null || value === undefined) return "";

  const parsed = Number(value);
  if (Number.isNaN(parsed)) return value;

  return Math.min(Math.max(parsed, min), max);
}

export function autoRangeFormat(
  datas,
  setLimitRightTop,
  setLimitLeftBottom,
  xLabel,
  yLabel,
) {
  const allPoints = datas.flatMap((data) => data.points);

  const allX = allPoints
    .map((p) => Number(p.x))
    .filter((v) => Number.isFinite(v) && (!xLabel.isLog || v > 0));

  const allY = allPoints
    .map((p) => Number(p.y))
    .filter((v) => Number.isFinite(v) && (!yLabel.isLog || v > 0));

  const minX = Math.min(...allX);
  const maxX = Math.max(...allX);
  const minY = Math.min(...allY);
  const maxY = Math.max(...allY);

  const xToView = xLabel.isLog ? Math.log10 : (x) => x;
  const yToView = yLabel.isLog ? Math.log10 : (y) => y;

  const xToWorld = xLabel.isLog ? (x) => 10 ** x : (x) => x;
  const yToWorld = yLabel.isLog ? (y) => 10 ** y : (y) => y;

  const minXV = xToView(minX);
  const maxXV = xToView(maxX);
  const minYV = yToView(minY);
  const maxYV = yToView(maxY);

  const xMargin = (maxXV - minXV) * 0.1;
  const yMargin = (maxYV - minYV) * 0.1;

  setLimitLeftBottom({
    x: xToWorld(minXV - xMargin),
    y: yToWorld(minYV - yMargin),
  });

  setLimitRightTop({
    x: xToWorld(maxXV + xMargin),
    y: yToWorld(maxYV + yMargin),
  });
}

export function save(data, xLabel, yLabel, axisFontSize,Legend,rightTop,leftBottom,zoomVelosity,height) {
  localStorage.setItem(
    "userData",
    JSON.stringify({
      data: data,
      rightTop:rightTop,
      leftBottom:leftBottom,
      xLabel: xLabel,
      yLabel: yLabel,
      fontSize: axisFontSize,
      legend:Legend,
      zoomVelosity:zoomVelosity,
      height:height
    }),
  );
  const dispModal = getFunctionData("displayModal")
  dispModal("保存が完了しました","データ系列、軸レンジ、ラベルデータ、フォントサイズを保存しました\n画面リロード時に復元されます")
}
